import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { Provider } from 'react-redux';

import store from './store/store';
import ResponsiveProvider from './components/ResponsiveProvider';

import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

// Aggiungi tutti gli icon packs alla libreria
library.add(fas);

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <Provider store={store}>
      <ResponsiveProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </ResponsiveProvider>
    </Provider>
  );
}
